<template>
  <div class="central-aircon-system">
    <div id="popular">
      <div class="none">
        <div class="a" onclick="toggle()"></div>
        <h1>资料下载</h1>
        <table>
          <tr>
            <th>文件名称</th>
            <th>文件格式</th>
            <th>文件大小</th>
            <th>操作</th>
          </tr>
          <tr v-for="(person, index) in arr" :key="index">
            <td>
              <div>{{ person.fileName }}</div>
            </td>
            <td>
              <div>{{ person.fileFormat }}</div>
            </td>
            <td>
              <div>{{ person.fileSize }}</div>
            </td>
            <td>
              <img
                @click="download(person.url, person.fileName)"
                src="../assets/img/buliding/icon_download.png"
                alt=""
              />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="acc"></div>

    <div id="blur">
      <header>
        <div class="main">
          <div class="banner"></div>

          <div class="left"></div>

          <div class="right"></div>
        </div>
      </header>

      <main>
        <div class="main">
          <div class="main-background1"></div>
          <div class="background2f"><div class="main-background2"></div></div>
          <div class="background3f"><div class="main-background3"></div></div>
          <div class="left"></div>
          <div class="center">
            <div class="main1">
              <div class="main1-background">SYSTEM</div>
              <!-- <h1>中央空调节能系统</h1> -->
              <h1>建筑智能化</h1>
              <p>
                涵盖了单一楼宇内的所有智能化与机电的建设/改造业务，包括但不限于写字楼，居民楼，海关关口，博物馆，美术馆，银行等；在此业务线中，昌恩较有代表性的案例有：…….（填写文锦渡，大百汇写字楼等）
              </p>
            </div>
            <div class="main2">
              <div class="mainCenter">
                <div class="dimg1">
                  <img
                    src="../assets/img/download1/建筑智能化_下载资源1@2x.png"
                    alt=""
                  />
                </div>
                <div class="main-text">
                  <h1>中央空调节能系统</h1>
                  <p>
                    智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                  </p>
                </div>
              </div>
            </div>
            <div class="main3">
              <div class="main-text">
                <h1>中央空调节能系统</h1>
                <p>
                  智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                </p>
              </div>
              <div class="dimg2">
                <img
                  src="../assets/img/download1/建筑智能化_中央空调系统2@2x.png"
                  alt=""
                />
              </div>
            </div>
            <div class="main4">
              <div class="main4-left">
                <div class="dimg3">
                  <img
                    src="../assets/img/download1/下载中心-中央空调系统.png"
                    alt=""
                  />
                </div>
                <p>联系电话：0755-83932176</p>
                <p>地址：深圳市盐田区沙头角深盐路保发大厦5楼整层</p>
                <button onclick="toggle()">
                  下载资料<img
                    src="../assets/img/download1/icon_more@2x.png"
                    alt=""
                  />
                </button>
              </div>
              <div class="main4-right">
                <div class="main-text">
                  <h1>中央空调节能系统</h1>
                  <p>
                    智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                  </p>
                </div>
                <div class="dimg4">
                  <img
                    src="../assets/img/download1/建筑智能化_中央空调系统3@2x.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="right"></div>
        </div>
      </main>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },

  name: "air",
  data() {
    return {
      arr: []
    };
  },
  created() {
    window.toggle = this.toggle;
  },
  mounted() {
    this.toggle2();
  },
  methods: {
    toggle() {
      var blur = document.getElementById("blur");
      blur.classList.toggle("active");
      var acc = document.getElementById("acc");
      acc.classList.toggle("active");
      var popular = document.getElementById("popular");
      popular.classList.toggle("active");
    },
    toggle2() {
      this.request.get("/information/3", {}).then(res => {
        this.arr = res.data.data;
      });
    },
    download(url, fileName) {
      window.open("https://www.szce.com/api/common/download/" + fileName);
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 1060px) {
  body .main3,
  body .main4 {
    width: 950px;
  }
  #popular .none {
    transform: scale(0.6);
  }
}
@media screen and (max-width: 1260px) and (min-width: 1060px) {
  body .main3,
  body .main4 {
    width: 1100px;
  }
  #popular .none {
    transform: scale(0.7);
  }
}
@media screen and (max-width: 1360px) and (min-width: 1260px) {
  #popular .none {
    transform: scale(0.8);
  }
}

footer .main .center {
  width: 1260px;
  margin: 0 auto;
}
header {
  height: 230px;
}
header .banner {
  background: url(../assets/img/download1/建筑智能化_下载资源_banner@2x.png)
    no-repeat;
  background-position: center;
  background-size: cover;
}
#blur.active {
  pointer-events: none;
  user-select: none;
}
#acc.active {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
#popular {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  height: 600px;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}
#popular .none {
  position: relative;
  width: 1200px;
  height: 100%;
  background-color: white;
  padding: 0.1042rem 0.2083rem 0 0.1042rem;
}
.none .a {
  position: absolute;
  right: -56px;
  top: -16px;
  display: block;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: url(../assets/img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}
.none h1 {
  margin-bottom: 0.1042rem;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.58);
  line-height: 24px;
}
.none table {
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border-bottom: 0.0052rem solid #000000;
  text-align: left;
  padding: 16px 100px;
}
th {
  color: rgba(0, 0, 0, 0.58);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
td {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.44);
  line-height: 22px;
}
#popular.active {
  top: 45%;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}
main {
  position: relative;
}
.main-background1 {
  position: absolute;
  position: absolute;
  top: 515px;
  width: 100%;
  height: 326px;
  background: #f5f6fb;
  z-index: -1;
}
.main-background2f {
  position: absolute;
  width: 100%;
  height: 536px;
  top: 1133px;
  left: 50%;
  margin-left: -253px;
}
.main-background2 {
  position: absolute;
  /* top: 1436px; */
  /* margin-left: -285px; */
  width: 100%;
  height: 536px;
  background: #f5f6fb;
  z-index: -1;
}

.main-background3 {
  position: absolute;
  width: 100%;
  height: 536px;
  background: #f5f6fb;
  z-index: -1;
}
.main1 {
  width: 1260px;
  left: 50%;
  position: relative;
  margin-left: -630px;
  height: 515px;
}
.main1-background {
  position: absolute;
  top: 144px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 163px;
  font-weight: normal;
  color: #fafafa;
  line-height: 187px;
  letter-spacing: 6px;
  z-index: -1;
}
.main1 h1 {
  position: absolute;
  top: 206px;
  left: 50%;
  transform: translate(-50%, 10px);
  font-size: 31px;
  color: #140047;
  line-height: 33px;
  letter-spacing: 1.92px;
  text-align: center;
}
.main1 p {
  position: absolute;
  display: block;
  width: 1024px;
  left: 50%;
  margin-left: -517px;
  top: 275px;
  height: 77px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #01021b;
  line-height: 33px;
  letter-spacing: 0.96px;
}
.main2 {
  width: 100%;
  position: relative;
  display: flex;
  margin-top: 80px;
  height: 460px;
}
.main2 .mainCenter {
  position: relative;
  height: 578px;
  width: 1280px;
  margin: 0 auto;
}
.dimg1 {
  /* width:1196px; */
  height: 470px;
}
.main2 .main-text {
  width: 634px;
  position: absolute;
  top: 131px;
  right: 0;
  height: 259px;
}
.main2 img {
  width: 93.5%;
  height: 100%;
  border: 1px dashed #808080;
}
.main2 .transform {
  width: 104px;
}
.main-text {
  padding: 60px;
  width: 780px;
  background: #ffffff;
  box-shadow: 0rem 0.0052rem 10px 0rem rgba(176, 183, 213, 0.2);
}
.main3 .main-text {
  margin-top: 115px;
  padding: 60px;
  width: 49%;
  /* height: 259px; */
  background: #ffffff;
  box-shadow: 0rem 0.0052rem 10px 0rem rgba(176, 183, 213, 0.2);
}
.main-text h1 {
  margin-bottom: 26px;
  /* margin-top: 49px; */
  font-size: 31px;
  color: #140047;
  line-height: 38px;
  letter-spacing: 1.92px;
}
.main-text p {
  font-size: 13px;
  font-weight: 400;
  color: #01021b;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 33px;
  letter-spacing: 0.96px;
}
.main3 {
  width: 1260px;
  margin-top: 224px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.main4 {
  display: -webkit-box;
  display: flex;
  width: 1260px;
  height: 651px;
  margin: 81px auto 0px;
  justify-content: space-between;
}
.main4-left {
  width: 49%;
  height: 449px;
}
.main4-left img {
  width: 100%;
  height: 100%;
}

.main4-left p:nth-child(2) {
  display: block;
  font-size: 16px;
  margin-top: 26px;
  margin-bottom: 13px;
  color: #192147;
  line-height: 23px;
  letter-spacing: 0.96px;
}
.main4-left p:nth-child(3) {
  height: 23px;
  font-size: 16px;
  margin-bottom: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #192147;
  line-height: 23px;
  letter-spacing: 1px;
}
.main4-left button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 163px;
  height: 42px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  font-size: 18px;
  font-weight: 600;
  color: #140047;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.3s;
}
.main4-left button img {
  width: 18px;
  height: 10px;
  margin-left: 36px;
}
.main4-right {
  margin-top: 136px;
  width: 47%;
}
.main4-right .main-text {
  padding: 60px;
  width: 100%;
  /* height: 259px; */
  margin-top: -13px;
  background: #ffffff;
  box-shadow: 0rem 0.0052rem 10px 0rem rgb(176 183 213 / 20%);
}
.dimg4 {
  /* width: 634px; */
  height: 111px;
}
.dimg4 img {
  margin-top: 32px;
  width: 100%;
  height: 100%;
}
button:hover {
  margin-left: 0.1563rem;
}

.dimg2 {
  margin-top: 182px;
  width: 47%;
  height: 460px;
}
.dimg2 img {
  width: 100%;
  height: 100%;
}
.main4-left .dimg3 {
  /* width:585px; */
  height: 449px;
}
.background2f {
  position: absolute;
  top: 1133px;
  width: 100%;
  height: 536px;
  z-index: -1;
  left: 50%;
  margin-left: -253px;
}
.background3f {
  position: absolute;
  top: 1910px;
  width: 100%;
  height: 536px;
  z-index: -1;
  right: 50%;
  margin-right: -366px;
}
</style>



// WEBPACK FOOTER //
// src/components/air.vue